import * as _ from 'underscore';
import { RecursiveList } from './recursiveList';
import { TableHeaderActionOptions, RecursiveTableOptions } from '../interfaces/options';
import { DefaultTableOptions } from '../const/defaultOptions';
import { Localization } from '../compile';

export class RecursiveTable extends RecursiveList {
	private customTableActions: TableHeaderActionOptions[];
	private tableOptions: RecursiveTableOptions;

	constructor(options?: RecursiveTableOptions) {
		options = $.extend(true, {}, DefaultTableOptions, options || {});
		super(options);
		this.tableOptions = <RecursiveTableOptions>this.options;

		//custom actions
		this.customTableActions = [];
		if (
			this.tableOptions.header &&
			_.isArray(this.tableOptions.header.customActions) &&
			this.tableOptions.header.customActions.length > 0
		) {
			this.customTableActions = this.tableOptions.header.customActions.map(customAction => {
				return _.defaults(customAction, <TableHeaderActionOptions>{
					icon: '',
					isActive: true,
					label: Localization.Actions,
					onClick: () => {}
				});
			});
		}
	}
}
